export default __webpack_public_path__ + "static/media/NouvelR-Regular.f31cb6c5.woff2";